import propTypes from 'prop-types';
import React from 'react';
import LinesEllipsis from 'react-lines-ellipsis';
import {Link} from 'react-router-dom';
import track from '../../telemetry';

const ContentPosts = ({
  sortedPosts,
  selectPost,
  currentPost,
  currentUser,
}) => {
  if (sortedPosts.length > 0) {
    return sortedPosts.map((post) => {
      return (
        <React.Fragment key={sortedPosts.indexOf(post)}>
          <Link
            to={`${currentUser.urlAddress}/${post.title.split(' ').join('-')}`}
            className="content-post"
            onClick={() => {
              track('post_opened', { source: 'content_list' });
              selectPost(post.title);
            }}
          >
            <LinesEllipsis
              className="content-post-title"
              text={`${post.title} `}
              ellipsis="... "
              basedOn="letters"
            />
          </Link>
        </React.Fragment>
      );
    });
  }
  return (
    <div
      className="content-post"
      key={-1}
      onClick={() => selectPost(-1)}
      onKeyPress={() => selectPost(-1)}
      tabIndex={0}
      role="button"
    >
      ( None )
    </div>
  );
};

ContentPosts.defaultProps = {
  sortedPosts: [],
  currentPost: {},
  currentUser: {},
  selectPost: () => {},
};

ContentPosts.propTypes = {
  sortedPosts: propTypes.oneOfType([propTypes.array]),
  currentPost: propTypes.oneOfType([propTypes.object]),
  currentUser: propTypes.oneOfType([propTypes.object]),
  selectPost: propTypes.func,
};

export default ContentPosts;
